import { Locales } from '../../../localization'

interface Props {
  dateString: string
  language: Locales
  timeZone: string
}

export const formatShortDate = ({ dateString, language, timeZone }: Props) => {
  const date = new Date(dateString)
  return date.toLocaleDateString(language, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone,
  })
}
